import React from 'react';
import './PricingAutomation.css';

export default function PricingAutomation() {
  return (
    <div className="pa-wrap">
      <section className="pa-hero-section">
        <div className="pa-container pa-hero-content">
          <div className="row">
            <div className="col-lg-12">

              <h1 className="pa-hero-title pa-serif mb-5">
                Are you still pricing the <br /> <span className="pa-text-orange">safaris by hand?</span>
              </h1>

              <p className="pa-hero-subtitle mb-5 pb-1">
                <span className="pa-text-white-bold">AI-powered, human-controlled.</span> Twigaa reads your contracts, rates and child/room policies and returns accurate costing for any group, season or hotel, with your own markups, so you stay in control of every quote.
              </p>

              <h4 className="pa-serif pa-highlight mb-4">Itinerary to quote to voucher in a few clicks.</h4>

              <div className="pa-feature-list mb-4 d-flex flex-wrap align-items-center">
                ITINERARIES <span className="pa-feature-dot pa-dot-orange">•</span>
                AUTO-COSTING <span className="pa-feature-dot pa-dot-light">•</span>
                CRM <span className="pa-feature-dot pa-dot-orange">•</span>
                MULTI-LINGUAL QUOTATIONS <span className="pa-feature-dot pa-dot-light">•</span>
                ACCOUNTS <span className="pa-feature-dot pa-dot-orange">•</span>
                VOUCHERS <span className="pa-feature-dot pa-dot-light">•</span>
                OPERATIONS
              </div>

              <div className="pa-callout mb-4">
                <span className="pa-text-gold fw-semibold">Exclusively designed for</span> East Africa and Southern Africa DMCs and travel operators
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pa-bottom-section">
        <div className="pa-container">
          <div className="row">
            <div className="col-lg-10">
              <p className="pa-bottom-text mb-4">
                <span className="pa-text-orange">Stop digging through contract PDFs.</span>{' '}
                Your team no longer has to search through contracts and rate sheets by hand. Twigaa reads them for you and gives you <span className="pa-text-white-bold">ready-to-use prices for any pax, property or child policy</span>, with your markups already applied and every quote still yours to approve.
              </p>

              <div className="d-flex flex-wrap gap-3 mt-4">
                <a className="pa-btn-orange"
                  onClick={() => window.gtag_report_conversion()}
                  href="https://forms.gle/GsaFJ4kCVUuUEftq5"
                  target="_blank"
                  rel="noopener noreferrer"
                >Book a demo</a>
                <a className="pa-btn-outline"
                  onClick={() => window.gtag_report_conversion()}
                  href="https://forms.gle/GsaFJ4kCVUuUEftq5"
                  target="_blank"
                  rel="noopener noreferrer"
                >See how it works</a>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}